import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from '../shared/global.service';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-multibanco',
  templateUrl: './multibanco.component.html',
  styleUrls: ['./multibanco.component.scss']
})
export class MultibancoComponent implements OnInit {
  details: any;
  isAtmPayment: boolean;
  expirationOffsetDays: number = 4;
  showExpirationDate: boolean = false;

  constructor(
    private _router: Router,
    private _globalService: GlobalService) { }

  async ngOnInit() {
    this.details = this._globalService.multibancoDetails;
  }

  printSection(id: string) {
    const src = document.getElementById(id);
    if (!src) return;

    let printRoot = document.getElementById('print-root');
    if (!printRoot) {
      printRoot = document.createElement('div');
      printRoot.id = 'print-root';
      document.body.appendChild(printRoot);
    }

    printRoot.innerHTML = '';
    const clone = src.cloneNode(true) as HTMLElement;
    printRoot.appendChild(clone);

    const imgs = Array.from(printRoot.querySelectorAll('img'));
    imgs.forEach(img => {
      img.removeAttribute('loading');
      const raw = img.getAttribute('src') || '';
      img.src = new URL(raw, document.baseURI).href;
    });
    const waitImages = Promise.all(
      imgs.map(img => (img.complete && img.naturalWidth > 0)
        ? Promise.resolve()
        : new Promise<void>(res => { img.onload = () => res(); img.onerror = () => res(); }))
    );

    document.body.classList.add('printing');

    waitImages.then(() => requestAnimationFrame(() => window.print()));

    const cleanup = () => {
      printRoot!.innerHTML = '';
      document.body.classList.remove('printing');
      window.removeEventListener('afterprint', cleanup);
    };
    window.addEventListener('afterprint', cleanup);
  }

  copyText(text: string) {
    navigator.clipboard.writeText(text);
  }

  isToShowExpirationDate() {
    return this.showExpirationDate;
  }

  formatExpirationDate(dateIso: string): string {
    const date = new Date(dateIso);
    date.setUTCDate(date.getUTCDate() - this.expirationOffsetDays);

    const finalDate = formatDate(date, `MMMM d, y 'at' h:mm a`, 'en-US');
    return `Expires ${finalDate}`;
  }

  remainingDaysForExpiration(dateIso: string): number {
    const date = new Date(dateIso);
    date.setUTCDate(date.getUTCDate() - this.expirationOffsetDays);

    const now = new Date();
    const diff = date.getTime() - now.getTime();
    const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
    
    return days;
  }

  async done() {
    this._globalService.clearMultibancoDetails();
    const isAtmPayment = true;

    await this._router.navigate(['../thankyou'], 
      {   
        queryParams: { isAtmPayment },
        queryParamsHandling: 'merge',
      }, 
    );
  }
}
